import React from 'react';

import TooltipShowcase from './TooltipShowcase';
import { tooltipSet } from './constants';

const Tooltips = () => (
  <section>
    <article>
      <ul className="showcase-list">
        {
          tooltipSet.map((group, i) => (
            <li key={`tooltip-showcase-${i}`}>
              <TooltipShowcase {...group} />
            </li>
          ))
        }
      </ul>
    </article>
  </section>
);

export default Tooltips;


// WEBPACK FOOTER //
// ./src/containers/elements/Tooltips/Tooltips.js